import moment from "moment";

window.wait = (time) => {
  return new Promise(resolve => {
    setTimeout(resolve, time);
  });
};

window.removeDiacritics = (text) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

window._downloadAsCsv = (fileName, rows) => {
  window._download(
    `${fileName}.csv`,
    'data:text/csv;charset=utf-8,\uFEFF'
    + rows
      .map(r => r
        .map(c => typeof c === 'string' && c.indexOf(',') !== -1 ? `"${c}"` : c)
        .map(c => typeof c === 'string' ? c.replace(/#/g, "") : c)
        .join(',')
      )
      .join('\n')
  )
};

window.downloadAsZip = (fileName, data) => {
  window._download(
    `${fileName}.zip`,
    'data:application/zip;base64,' + data
  )
};

/**
 * @param {String} name
 * @param {String} value
 * @param {Date} expirationDate
 */
let COOKIE_PREFIX = "ishopfood-admin-";
window.setCookie = function(name, value, expirationDate = new Date(9999, 1, 1)) {
  let expiresOn = "; expires=" + expirationDate.toUTCString();
  document.cookie = COOKIE_PREFIX + name + "=" + value  + expiresOn + "; path=/";
};

/**
 * @param {String} name
 * @return {String} cookie value
 */
window.getCookie = function(name) {
  let name_equals = COOKIE_PREFIX + name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(name_equals) === 0) {
      return c.substring(name_equals.length,c.length);
    }
  }
  return null;
};

let spinnerStack = 0;
window.showSpinner = function() {
  let spinner = document.getElementById("spinner");
  if (spinner) {
    if (spinnerStack == 0) {
      spinner.classList.add("show");
    }
  }
  spinnerStack++;
};
window.hideSpinner = function() {
  if (spinnerStack > 0) {
    spinnerStack--;
  }
  if (spinnerStack == 0 && document.getElementById("spinner")) {
    document.getElementById("spinner").classList.remove("show");
  }
};

window.generateUUID = function() {
  let chars = [];
  for (let i = 48; i <= 57; i++) {
    chars.push(i);
  }
  for (let i = 65; i <= 90; i++) {
    chars.push(i);
  }
  for (let i = 97; i <= 122; i++) {
    chars.push(i);
  }
  let uuid = "";
  for (let i = 0; i < 32; i++) {
    uuid += String.fromCharCode(chars[Math.floor(Math.random() * chars.length)]);
  }
  return uuid;
}

window.isValidHttpUrl = function(string) {
  let url;
  try {
    url = new URL(string);
  } catch (e) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}

window.deepCopy = function(json) {
  return JSON.parse(JSON.stringify(json));
}

window.tryParseAsJson = function(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

window.isValidJSON = function(text) {
    try {
      JSON.parse(text);
    } catch (e) {
      return false;
    }
    return true;
};

window.showConfirmation = function(title, text, confirmText, cancelText) {
  return new Promise(resolve => {
    document.querySelector("#modalConfirmation .modal-header").innerHTML = title;
    document.querySelector("#modalConfirmation .modal-body .content").innerHTML = text;
    document.querySelector("#modalConfirmation .modal-yes").innerHTML = confirmText || window.translate("yes");
    document.querySelector("#modalConfirmation .modal-no").innerHTML = cancelText || window.translate("no");
    document.querySelector("#modalConfirmation .modal-yes").onclick = function() {
      resolve(true);
      document.getElementById("modalConfirmation").classList.remove("show");
    };
    document.querySelector("#modalConfirmation .modal-no").onclick = function() {
      resolve(false);
      document.getElementById("modalConfirmation").classList.remove("show");
    };
    document.getElementById("modalConfirmation").classList.add("show");
  });
};

window.showAffirmation = function(title, text, buttonText) {
  return new Promise(resolve => {
    document.querySelector("#modalAffirmation .modal-header").innerHTML = title;
    document.querySelector("#modalAffirmation .modal-body .content").innerHTML = text;
    document.querySelector("#modalAffirmation .modal-ok").innerHTML = buttonText || window.translate("ok");
    document.querySelector("#modalAffirmation .modal-ok").onclick = function() {
      resolve();
      document.getElementById("modalAffirmation").classList.remove("show");
    };
    document.querySelector("#modalAffirmation .modal-header").style.paddingLeft = "";
    document.getElementById("modalAffirmation").classList.add("show");
  });
};

window._exportAsJson = (filename, data) => {
  let dataStr = JSON.stringify(data);
  let dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
  let exportFileDefaultName = filename + '.json';
  let link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('href', dataUri);
  link.setAttribute('download', exportFileDefaultName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

window._download = (fileName, data) => {
  let link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', data);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

window.getBase64Data = (url) => {
  return url.replace(/^data:image\/(png|jpeg|gif);base64,/, "");
};

window.isExecutable = () => {
  return typeof nw !== "undefined";
}

/**
 * @param {*} message
 */
window.logToFile = function(message) {
  if (!window.isExecutable()) {
    return;
  }
  let fs = nw.require("fs");
  let now = new Date();
  let timestamp = "[" + now.toLocaleString() + "] ";
  let today = now.toISOString().slice(0, 10);
  if (typeof message !== "string") {
    message = JSON.stringify(message);
  }
  message = timestamp + message + "\r\n";
  fs.appendFile("./logs/" + today + ".log", message, "utf8", (error) => {
    if (error) {
      console.log("FILE LOG ERROR", error);
    }
  });
}

window.getImageData = function(obj) {
  if (!obj) {
    return undefined;
  }
  return obj.base64 ? obj.base64 : (obj.deleted ? null : undefined)
};

window.formatHour = function(format, hour) {
  let h = parseInt(hour.substring(0, 2));
  let m = parseInt(hour.substring(3));
  if (h <= 24) {
    h = h % 24;
  }
  let parsed = moment().set({
    hour: h,
    minutes: m
  });
  if (!parsed.isValid()) {
    return null;
  }

  if (format == "12") {
    return parsed.format("hh:mm A");
  } else {
    return parsed.format("HH:mm");
  }
};

window.formatDateTime = function(format, datetime) {
  let date = moment(datetime);

  if (!date.isValid()) {
    return null
  }

  if (format == "12") {
    return date.format("YYYY-MM-DD hh:mm A");
  } else {
    return date.format("YYYY-MM-DD HH:mm");
  }
};

window.B_IN_MB = 1048576;
window.MAX_FILE_SIZE = 40 * window.B_IN_MB;

/**
 * CSS Class name must be 'editable-ELEMENT' where ELEMENT is the name of the field provided in the whitelist.
 * @param {string[]} whitelist
 */
window.lockFields = function(whitelist = []) {
  setTimeout(() => {
    let inputs = document.getElementsByTagName("input");
    let textareas = document.getElementsByTagName("textarea");
    let selects = document.getElementsByTagName("select");
    let multiselects = document.getElementsByClassName("multi-select");
    let listMultiselects = document.getElementsByClassName("listMultiSelect");
    let fields = [...inputs, ...textareas, ...selects, ...multiselects, ...listMultiselects];

    //Disable all fields not in whitelist
    for (let i = 0; i <  fields.length; i++) {
      let field = fields[i];
      let inWhitelist = whitelist.find(w => field.classList.contains("editable-" + w));
      if (!inWhitelist) { //Not allowed
        field.setAttribute("disabled", true);
        field.setAttribute("readonly", true);
        field.classList.add("disabled");
        field.style.borderColor = "#d9d9d9";
      } else { //Allowed
        field.removeAttribute("disabled");
        field.removeAttribute("readonly");
        field.classList.remove("disabled");
        field.style.borderColor = "#b9e2a4";
      }
    }

    //Disable image upload
    let buttons = document.querySelectorAll(".imageUpload .group:first-child label, .imageUpload .input-group");
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].style.display = "none";
    }
  });
};

/**
 * @param {HTMLElement} parentElement
 */
window.hideButtons = function(parentElement) {
  let root = parentElement || document;
  let buttons = Array.from(root.getElementsByClassName("btn"));
  for (let button of buttons) {
    button.style.display = "none";
  }
}
